/**
 * Owner: Haselton Baker Risk Group, LLC
 * Product: SP3 - SP3-Portfolio-UI
 * Date: 8/10/21
 * Copyright All Rights Reserved
 */

import { analysisTypesById } from 'constants/analysisTypes';

const paramsAreSet = (type, params) => (
  type && analysisTypesById[type].searchParams.every(val => params[val])
);

export default paramsAreSet;



// WEBPACK FOOTER //
// ./js/support/paramsAreSet.js